<template>
    <div padding>
        <q-table :data="rewards" :columns="columns" @request="request" :loading="loading" row-key="name"
            :no-data-label="$t('no_data_avaliable')" :no-results-label="$t('no_results_found')"
            :loading-label="$t('loading_data')" hide-bottom :pagination="{ rowsPerPage: 0 }">

            <template slot="top" slot-scope="props" :props="props">
                <div class="col" />

                <q-btn color="secondary" icon="far fa-plus" :label="$t('new')" @click="voucherDialogShow()" />
            </template>

            <q-tr slot="header" slot-scope="props" :props="props">
                <q-th v-for="col in props.cols" :key="col.name" :props="props">
                    {{ $t(col.label) }}
                </q-th>
            </q-tr>

            <q-tr slot="body" slot-scope="props" :props="props">
                <q-td auto-width key="id" :props="props">
                    {{ props.row.id }}
                </q-td>

                <q-td key="voucher_code" :props="props">
                    {{ props.row.voucher_code }}
                </q-td>

                <q-td key="user" :props="props">
                    {{ props.row.user }}
                </q-td>

                <q-td key="created_date" :props="props">
                    {{ formatDate(props.row.created_date) }}
                </q-td>

                <q-td key="status" :props="props" auto-width>
                    <q-chip small :icon="getIconStatus(props.row.status)" :color="getColorStatus(props.row.status)"
                        class="full-width">
                        {{ $t(getStatus(props.row.status)) }}
                    </q-chip>
                </q-td>

                <q-td key="actions" :props="props">
                    <q-btn flat round color="negative" icon="far fa-trash-alt" @click="confirmRemove(props.row.actions)"
                        v-if="!props.row.user">
                        <q-tooltip>
                            {{ $t('delete_tooltip') }}
                        </q-tooltip>
                    </q-btn>
                </q-td>
            </q-tr>
        </q-table>

        <q-dialog v-model="confirm_remove" @ok="removeItem">
            <span slot="title">{{ $t('remove_item') }}</span>

            <span slot="message">{{ $t('confirm_remove_item') }}</span>

            <template slot="buttons" slot-scope="props" :props="props">
                <q-btn color="secondary" :label="$t('cancel')" @click="confirm_remove = false" />
                <q-btn color="negative" :label="$t('remove')" @click="removeItem()" />
            </template>
        </q-dialog>

        <q-dialog v-model="show_dialog_reward" @ok="removeItem">
            <span slot="title">{{ $t('voucher') }}</span>

            <span slot="body">
                <q-input v-model="voucher_dialog_code" :float-label="$t('redeem_code')" />
            </span>

            <template slot="buttons" slot-scope="props" :props="props">
                <q-btn color="secondary" :label="$t('cancel')" @click="show_dialog_reward = false" />
                <q-btn color="secondary" :label="$t('add')" @click="confirmVoucherDialog()" />
            </template>
        </q-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import formatDate from '../../../pages/admin/rewards/utils/formatDate';

export default {
    i18nOptions: { namespaces: ["custom", "rewards", "admin", "common", "users"] },

    props: ['reward_id'],

    data() {
        return {
            server_pagination: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: null,
                descending: false,
                sortBy: null
            },
            loading: false,
            rewards: [],
            columns: [
                {
                    name: 'id',
                    required: true,
                    label: '#',
                    align: 'left',
                    field: 'name',
                    sortable: true,
                },
                {
                    name: 'voucher_code',
                    required: true,
                    label: 'Código do voucher',
                    align: 'left',
                    field: 'voucher_code',
                    sortable: true,
                },
                {
                    name: 'user',
                    required: true,
                    label: 'user',
                    align: 'left',
                    field: 'user',
                    sortable: true,
                },
                {
                    name: 'created_date',
                    required: true,
                    label: 'Data do resgate',
                    align: 'center',
                    field: 'created_date',
                    sortable: true,
                },
                {
                    name: 'status',
                    required: true,
                    label: 'status',
                    align: 'center',
                    field: 'status',
                    sortable: true,
                },
                {
                    name: 'actions',
                    required: true,
                    label: '',
                    align: 'right',
                    field: 'edit',
                    sortable: false,
                },
            ],
            action_id: '',
            confirm_remove: false,
            show_report_reward: false,
            id: '',
            title: '',
            voucher_dialog_code: '',
            voucher_dialog_id: null,
            show_dialog_reward: false
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            user_clients: 'common/user_clients',
            areas: 'registration_lists/country_areas',
            user_groups: 'registration_lists/group_users',
            profiles: 'registration_lists/profiles',
            tags: 'registration_lists/tags',
            reports: 'registration_lists/reports',
            num_rows: 'datatable/num_rows'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        }
    },

    methods: {
        request({ pagination }) {
            this.loading = true
            this.server_pagination = pagination

            let order = pagination.descending ? '-' : ''
            let order_by = pagination.sortBy ? order + pagination.sortBy : ''

            let data = {
                "page_size": this.server_pagination.rowsPerPage,
                "page": this.server_pagination.page,
                "ordering": order_by
            }

            this.savePagination()

            this.$axios.get(`/admin_rewards_store/reward_products/${this.reward_id}/reward_product_vouchers/?${this.$qs.stringify(data)}`, this.getHeader)
                .then(response => {
                    this.server_pagination.rowsNumber = response.data.count

                    this.rewards = response.data.map(r => {
                        return {
                            ...r, actions: r.id,
                        }
                    })
                })
                .catch(e => {
                    console.log(e)
                })
                .finally(() => {
                    this.loading = false
                })
        },

        confirmRemove(id) {
            this.action_id = id
            this.confirm_remove = true
        },

        voucherDialogShow(id = null, code = '') {
            this.voucher_dialog_id = id
            this.voucher_dialog_code = code
            this.show_dialog_reward = true
        },

        confirmVoucherDialog() {
            this.$axios.post(`/admin_rewards_store/reward_products/${this.reward_id}/reward_product_vouchers/`, {
                "voucher_code": this.voucher_dialog_code
            }, this.getHeader).then(() => {
                this.request({
                    pagination: this.server_pagination
                })
                this.show_dialog_reward = false
                this.$q.notify({
                    message: this.$t('reward_save_success'),
                    type: 'positive',
                    icon: 'fal fa-save',
                })
            }).catch((e) => {
                console.log(e)

                this.$q.notify({
                    message: this.$t('reward_save_error'),
                    type: 'negative',
                    icon: 'fal fa-ban',
                })
            })
        },

        removeItem() {
            this.$q.loading.show()

            this.$axios.delete(`/admin_rewards_store/reward_products/${this.reward_id}/reward_product_vouchers/${this.action_id}/`, this.getHeader)
                .then(response => {
                    this.request({
                        pagination: this.server_pagination
                    })

                    this.confirm_remove = false

                    this.$q.notify({
                        message: this.$t('item_removed_success'),
                        type: 'positive',
                        icon: 'far fa-trash-alt'
                    })
                })
                .catch(e => {
                    console.log(e)
                })
                .finally(() => {
                    this.$q.loading.hide()
                })
        },

        showReport(reward) {
            this.id = reward.id
            this.title = reward.title
            this.show_report_reward = true
        },

        hideReport() {
            this.show_report_reward = false
            this.id = ''
            this.title = ''
        },

        getStatus(status) {
            if (status == 1) return 'available'
            else if (status == 2) return 'used'
        },

        getIconStatus(status) {
            if (status == 1) return 'fas fa-check'
            else if (status == 2) return 'fas fa-check'
            else if (status == 3) return 'fas fa-trash-alt'
        },

        getColorStatus(status) {
            if (status == 1) return 'positive'
            else if (status == 2) return 'info'
            else if (status == 3) return 'negative'
        },

        savePagination() {
            this.$store.dispatch('datatable/SET_NUM_ROWS', [this.server_pagination.rowsPerPage])
        },

        loadPagination() {
            this.server_pagination.rowsPerPage = this.num_rows
        },

        formatDate(date) {
            return formatDate(date, this.id_user_language_selected)
        }
    },

    created() {
        this.loadPagination()
        this.request({
            pagination: this.server_pagination
        })
    }
}
</script>
